import Joi from 'joi';

export type Phrases = string[];
export const phrasesSchema = Joi.array().items(Joi.string()).required();

export type LoadPhrasesResponse = Phrases;
export const loadPhrasesResponseSchema = phrasesSchema;
